import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { INSIGHTS, BOOKING_URL } from "@/data/site";

export default function InsightDetail() {
  const { slug } = useParams();
  const post = INSIGHTS.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="container-cc py-32 text-center" data-testid="insight-not-found">
        <h1 className="font-serif-display text-4xl mb-4">Article not found.</h1>
        <Link to="/insights" className="link-underline">Back to insights <ArrowUpRight size={16} /></Link>
      </div>
    );
  }

  const related = INSIGHTS.filter((p) => p.slug !== slug).slice(0, 2);

  return (
    <article data-testid="insight-detail-page">
      <section className="pt-16 pb-12 md:pt-24 border-b border-[#E5E5E5]">
        <div className="container-cc max-w-4xl">
          <Link to="/insights" className="inline-flex items-center gap-2 text-sm text-[#525252] hover:text-[#A60201] mb-10" data-testid="back-to-insights">
            <ArrowLeft size={16} /> All Insights
          </Link>
          <div className="overline text-[#A60201] mb-5">{post.category}</div>
          <h1 className="font-serif-display text-4xl md:text-6xl leading-[1.05]">{post.title}</h1>
          <div className="text-sm text-[#525252] mt-6">{post.date} · {post.readTime}</div>
        </div>
      </section>

      <section className="py-12">
        <div className="container-cc max-w-4xl">
          <div className="aspect-[16/9] overflow-hidden mb-12">
            <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
          </div>
          <div className="space-y-6 text-lg text-[#0A0A0A] leading-relaxed">
            {post.body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>
      </section>

      <section className="section bg-white border-t border-[#E5E5E5]">
        <div className="container-cc">
          <div className="flex items-end justify-between mb-10">
            <h3 className="font-serif-display text-3xl md:text-4xl">Keep reading</h3>
            <Link to="/insights" className="link-underline">All insights <ArrowUpRight size={16} /></Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {related.map((r) => (
              <Link key={r.slug} to={`/insights/${r.slug}`} className="group" data-testid={`related-${r.slug}`}>
                <div className="aspect-[4/3] overflow-hidden mb-5 bg-[#F3F4F6]">
                  <img src={r.image} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="overline text-[#A60201] mb-2">{r.category}</div>
                <h4 className="font-serif-display text-2xl leading-tight group-hover:text-[#A60201]">{r.title}</h4>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="bg-[#FEBE98] p-10 md:p-14">
            <h2 className="font-serif-display text-3xl md:text-4xl max-w-2xl leading-tight">Bring this thinking into your organization.</h2>
            <div className="mt-6 flex flex-wrap gap-4">
              <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-primary" data-testid="insight-book-call">Book Discovery Call <ArrowUpRight size={16} /></a>
            </div>
          </div>
        </div>
      </section>
    </article>
  );
}
